const handleRefineClick = () => {
  const keys = [];
  const params = new URLSearchParams(window.location.search);
  params.forEach((v, k) => { keys.push(k); });
  keys.filter(k => k.includes('measurement')).forEach((p) => { params.delete(p); });

  const widthSelect = document.getElementById('Width1');
  if (widthSelect.value !== 'any') {
    const widthFractionSelect = document.getElementById('Width2');
    let width = parseFloat(widthSelect.value);
    width += parseFloat(widthFractionSelect.value);
    params.set('measurement.width', width.toFixed(3));
  }

  const heightSelect = document.getElementById('Height1');
  if (heightSelect.value !== 'any') {
    const heightFractionSelect = document.getElementById('Height2');
    let height = parseFloat(heightSelect.value);
    height += parseFloat(heightFractionSelect.value);
    params.set('measurement.height', height.toFixed(3));
  }

  const url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;
  if (params.toString().length === 0) {
    window.location.assign(url);
  } else {
    window.location.assign(`${url}?${params.toString()}`);
  }
};

const setupWidthSelection = () => {
  const params = new URLSearchParams(window.location.search);
  const width = params.get('measurement.width');
  if (!width) {
    return;
  }

  const split = width.split('.');
  if (split.length !== 2) {
    return;
  }

  const [main, fraction] = split;
  const widthSelect = document.getElementById('Width1');
  const widthFractionSelect = document.getElementById('Width2');
  widthSelect.value = main;
  widthFractionSelect.value = `.${fraction}`;
};

const setupHeightSelection = () => {
  const params = new URLSearchParams(window.location.search);
  const height = params.get('measurement.height');
  if (!height) {
    return;
  }

  const split = height.split('.');
  if (split.length !== 2) {
    return;
  }

  const [main, fraction] = split;
  const heightSelect = document.getElementById('Height1');
  const heightFractionSelect = document.getElementById('Height2');
  heightSelect.value = main;
  heightFractionSelect.value = `.${fraction}`;
};

const setupRefineClick = () => {
  const refineBtn = document.getElementById('refine-btn');
  if (refineBtn) {
    refineBtn.onclick = handleRefineClick;
  }

  const modalRefineBtn = document.getElementById('modal-dim-refine-btn');
  if (modalRefineBtn) {
    modalRefineBtn.onclick = handleRefineClick;
  }
};

setupWidthSelection();
setupHeightSelection();
setupRefineClick();
